module.exports = __webpack_public_path__ + "img/data-visualization.42bc81a9.png";